export default "![TradingView Charts](/img/changelog/trading_view_charts.png)\n";